import React, { useEffect } from 'react';

import { CheckBox, Input } from 'formlabs-web-components/Form';
import { AccordionItem } from 'formlabs-web-components/Media';

import filterLoadingAnimation from '../../../../public/filter-loading.svg';

import './Filter.module.css';

const setParams = params => {
  window.history.replaceState(
    null,
    '',
    params.toString() ? '?' + params.toString() : window.location.pathname
  );
};

const Filter = ({
  id,
  activeOptions,
  storeId,
  updateFilter,
  structure,
  updateUrlParams
}) => {
  const { loading, data } = structure();

  useEffect(
    () => {
      if (data) {
        const params = new URLSearchParams(window.location.search);
        const { paramsKey } = data;
        const queryParams = params.getAll(paramsKey);
        updateFilter(id, queryParams);
      }
    },
    [loading]
  );

  if (loading || !data) {
    return (
      <div styleName="loading">
        <img src={filterLoadingAnimation} alt="" />
      </div>
    );
  }

  const { label, options, paramsKey } = data;

  const setFilterOption = event => {
    const value = event.target.value;
    if (typeof window !== 'undefined' && updateUrlParams) {
      const params = new URLSearchParams(window.location.search);
      const currentParams = params.getAll(paramsKey);
      if (currentParams.includes(value)) {
        params.delete(paramsKey);
        currentParams
          .filter(param => param !== value)
          .map(value => params.append(paramsKey, value));
      } else {
        params.append(paramsKey, value);
      }
      setParams(params);
    }
    updateFilter(id, [value]);
  };

  return (
    <AccordionItem open title={label.replace('Filter: ', '')}>
      <ul styleName="list">
        {options.map(option => (
          <li key={option.value}>
            <CheckBox
              variant="blue"
              value={option.value}
              checked={activeOptions.includes(option.value)}
              onChange={setFilterOption}
            >
              {option.label}
            </CheckBox>
          </li>
        ))}
      </ul>
    </AccordionItem>
  );
};

const InputFilter = ({ id, updateFilter, label, value, placeholder }) => {
  const setFilterOption = event => {
    updateFilter(id, event.target.value);
  };

  return (
    <AccordionItem open title={label}>
      <Input
        value={value}
        onChange={setFilterOption}
        placeholder={placeholder}
      />
    </AccordionItem>
  );
};

export default Filter;
export { InputFilter };
